(function () {
  if (window.__aspCompareLoaded) return;
  window.__aspCompareLoaded = true;

  function root() {
    return document.querySelector('[data-asp-compare-root]');
  }

  function show() {
    window.__ASP_COMPARE__ = true;
    var el = root();
    if (!el) return false;
    el.hidden = false;
    el.classList.add('is-visible');
    document.documentElement.dataset.aspCompare = 'on';
    return true;
  }

  function hide() {
    window.__ASP_COMPARE__ = false;
    var el = root();
    if (!el) return;
    el.hidden = true;
    el.classList.remove('is-visible');
    delete document.documentElement.dataset.aspCompare;
  }

  window.aspEnableCompare = show;
  window.aspDisableCompare = hide;

  function previewOn() {
    try {
      var q = new URLSearchParams(window.location.search).get('asp_compare');
      return q === '1' || q === 'true';
    } catch (e) {
      return false;
    }
  }

  function boot() {
    if (previewOn() || window.__ASP_COMPARE__) show();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
})();
